export default __webpack_public_path__ + "static/media/ao.cf00f148.svg";